export default __webpack_public_path__ + "static/media/kitchen3-after1-2048w.281ced7f.png";